/**
 * Die Darstellung zu jedem Kacheltyp (D-07, BE-06). Die Liste der Typen samt
 * Titel und Beschreibung steht rein in `domain/oberflaeche/kacheln.ts`.
 */
import type { ComponentType } from 'react';

import {
  AusgabenKachel, BereicheKachel, TageskennzahlenKachel, ZeitFortschrittKachel, GewohnheitenHeuteKachel, HeuteKachel, KalenderKachel, UeberfaelligKachel, ZeitverteilungKachel, ZukunftKachel,
} from '@/modules/dashboard/UebersichtKacheln';
import {
  AufgabenKachel, DeadlinesKachel, ErnaehrungKachel, GewohnheitenKachel, ListenKachel, NotizenKachel, ProjekteKachel, StatistikKachel,
  StatusKachel, TermineKachel, TrainingKachel, WissenKachel, ZieleKachel,
} from '@/modules/areas/board/BereichKacheln';

import { MuskelnKachel, NaehrwerteKachel, WochenplanKachel } from '@/modules/areas/board/GesundheitKacheln';
import {
  SchuleFaecherKachel, SchuleHausaufgabenKachel, SchuleHeuteKachel, SchuleKlausurenKachel, SchuleLernzeitKachel,
  SchuleNotenKachel, SchuleStundenplanKachel, SchuleVerlaufKachel,
} from '@/modules/areas/board/SchuleKacheln';
import { FinanzAbosKachel, FinanzBuchungenKachel, FinanzBudgetKachel, FinanzVerlaufKachel } from '@/modules/finanzen/FinanzKacheln';
import { FinanzSparzieleKachel } from '@/modules/finanzen/SparzielKacheln';

export const KACHEL_KOMPONENTEN: Record<string, ComponentType> = {
  heute: HeuteKachel, tageskennzahlen: TageskennzahlenKachel, 'zeit-fortschritt': ZeitFortschrittKachel, ausgaben: AusgabenKachel, ueberfaellig: UeberfaelligKachel, 'gewohnheiten-heute': GewohnheitenHeuteKachel, kalender: KalenderKachel,
  zeitverteilung: ZeitverteilungKachel, bereiche: BereicheKachel, zukunft: ZukunftKachel,
  'b-status': StatusKachel, 'b-training': TrainingKachel, 'b-ernaehrung': ErnaehrungKachel, 'b-aufgaben': AufgabenKachel,
  'b-gewohnheiten': GewohnheitenKachel, 'b-ziele': ZieleKachel, 'b-projekte': ProjekteKachel, 'b-deadlines': DeadlinesKachel,
  'b-termine': TermineKachel, 'b-statistik': StatistikKachel, 'b-wissen': WissenKachel, 'b-notizen': NotizenKachel, 'b-listen': ListenKachel,
  'g-wochenplan': WochenplanKachel, 'g-muskeln': MuskelnKachel, 'g-naehrwerte': NaehrwerteKachel,
  's-heute': SchuleHeuteKachel, 's-stundenplan': SchuleStundenplanKachel, 's-noten': SchuleNotenKachel,
  's-faecher': SchuleFaecherKachel, 's-verlauf': SchuleVerlaufKachel, 's-hausaufgaben': SchuleHausaufgabenKachel, 's-klausuren': SchuleKlausurenKachel,
  's-lernzeit': SchuleLernzeitKachel,
  'f-budget': FinanzBudgetKachel, 'f-verlauf': FinanzVerlaufKachel, 'f-abos': FinanzAbosKachel, 'f-sparziele': FinanzSparzieleKachel, 'f-buchungen': FinanzBuchungenKachel,
};
